import {useEffect, useState} from "react";
import {ItemsDetailProps} from "../interface/CommonInterface";
import {useMutation} from "@tanstack/react-query";
import {createCodeEntriesApi, deleteCodeEntriesApi, updateCodeEntriesApi} from "../../../../api/code/CodeApi";
import {typesDetailInit} from "../itemList/init/TypeListInit";
import AuthorityChecker from "../../../../components/common/authorityGuard/AuthorityChecker";
import {useUser} from "../../../../util/userContext/UserContext";

export const ItemsDetail = ({
                                types,
                                typesDetail,
                                menuId,
                                isAddItem,
                                setIsAddItem,
                                setIsModify,
                                setIsAddComplete,
                                setIsDeleteComplete
                            }: ItemsDetailProps) => {

    const [param, setParam] = useState(typesDetailInit);

    const {user} = useUser()

    useEffect(() => {
        if (!isAddItem) {
            setParam(typesDetail)
        } else {
            setParam({
                ...typesDetailInit,
                codeTypeId: types.codeTypeId,
            });
        }
    }, [typesDetail, isAddItem, types]);

    const addItems = () => {
        if (isAddItem) {
            createCodeEntriesApiMutate.mutate();
        } else {
            updateCodeEntriesApiMutate.mutate();
        }
    }

    const createCodeEntriesApiMutate = useMutation({
        mutationFn: () => createCodeEntriesApi(param),
        onSuccess: (res) => {
            if (res.data.code === "0000") {
                setIsAddItem(false)
                setIsAddComplete(true);
            } else {
                alert("서비스 오류가 있습니다.");
            }
        },
        onError: (error) => {
            alert(`API 호출 중 오류가 발생했습니다: ${error}`);
        },
    });

    const updateCodeEntriesApiMutate = useMutation({
        mutationFn: () => updateCodeEntriesApi(param),
        onSuccess: (res) => {
            if (res.data.code === "0000") {
                setIsModify(true)
            } else {
                alert("서비스 오류가 있습니다.");
            }
        },
        onError: (error) => {
            alert(`API 호출 중 오류가 발생했습니다: ${error}`);
        },
    });

    const deleteCodeEntriesApiMutate = useMutation({
        mutationFn: () => deleteCodeEntriesApi(param),
        onSuccess: (res) => {
            if (res.data.code === "0000") {
                setIsDeleteComplete(true)
            } else {
                alert("서비스 오류가 있습니다.");
            }
        },
        onError: (error) => {
            alert(`API 호출 중 오류가 발생했습니다: ${error}`);
        },
    });


    return (
        <>
            <div className="item_box3">
                <div className="fiter_top">
                    <h3 className="filter_heading">항목 {isAddItem ? "추가" : "상세"}</h3>
                    <div className="filter_toolbar">
                        <AuthorityChecker authorityNames={['itemWriteYn']}>
                            {
                                menuId === 1 ?
                                    <>
                                        {!isAddItem && <button className="btn btn-outline-dark w-100px"
                                                               onClick={() => deleteCodeEntriesApiMutate.mutate()}><img
                                            src={process.env.PUBLIC_URL + "/assets/images/icon_cross.png"} alt=""/>선택삭제
                                        </button>}
                                        <button className="btn btn-secondary w-100px"
                                                onClick={() => addItems()}>{isAddItem ? "저장" : "수정"}</button>
                                    </>
                                    : null
                            }
                        </AuthorityChecker>
                    </div>
                </div>

                <h5 className="subheading">항목 {isAddItem ? "추가" : "조회"}</h5>

                <table className="table table-bordered my_table table_detail">
                    <tbody>
                    <tr>
                        <th style={{width: "5.66%"}}>항목명</th>
                        <td className="p-4px" style={{width: "31.3%"}}>
                            <input
                                type="text"
                                className="form-control"
                                name="items-name"
                                value={param?.codeEntriesName || ""}
                                disabled={menuId === 2 || user?.authority.itemWriteYn === "N"}
                                onChange={(e) => setParam((prev) => ({...prev, codeEntriesName: e.target.value}))}
                            />
                        </td>
                    </tr>
                    <tr>
                        <th>비고</th>
                        <td className="p-4px">
                            <input
                                type="text"
                                className="form-control"
                                name="items-remark"
                                value={param?.remark || ""}
                                disabled={menuId === 2 || user?.authority.itemWriteYn === "N"}
                                onChange={(e) => setParam((prev) => ({...prev, remark: e.target.value}))}
                            />
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </>
    );
}